<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">Are you still there?</div>

    <div class="modal-body cl-form">
      <p class="cl-p-large">  If not we will close this session in: @if (this.idle.onTimeoutWarning | async; as to) {
        {{to}}
      } @else {
        {{ this.idle.getTimeout() }}
      }
    </p>
  </div>

</div>
</div>
